import { render, staticRenderFns } from "./police_action.vue?vue&type=template&id=5cc3dc63&scoped=true&"
import script from "./police_action.vue?vue&type=script&lang=js&"
export * from "./police_action.vue?vue&type=script&lang=js&"
import style0 from "./police_action.vue?vue&type=style&index=0&id=5cc3dc63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc3dc63",
  null
  
)

export default component.exports